// Enhanced initialize function with Safari fixes
function initTestimonialSliders() {
  // Force layout recalculation for Safari
  document.body.offsetHeight;
  
  // Create constants for common configurations
  var commonArrows = {
    prevArrow:
      '<div class="slick-slider__prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></div>',
    nextArrow:
      '<div class="slick-slider__next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></div>',
  };

  const commonSettings = {
    ...commonArrows,
    // Safari-specific optimizations
    touchThreshold: 10,
    waitForAnimate: false,
    useTransform: true,
    respondTo: "slider"
  };

  const sliderConfigs = [
    {
      selector: ".testimonial-slider",
      options: {
        ...commonSettings,
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4.5,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1800,
            settings: {
              slidesToShow: 3.5
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.2,
              arrows: false
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.2,
              arrows: false
            }
          }
        ]
      }
    }
  ];

  // Enhanced initialization with error handling
  sliderConfigs.forEach(({ selector, options }) => {
    const $slider = $(selector);
    if (!$slider.length) return;

    try {
      // Hide slider during initialization to prevent FOUC
      $slider.css("visibility", "hidden");
      
      // Initialize with error handling
      $slider.slick(options);
      
      // Force slider refresh and show
      setTimeout(() => {
        $slider.slick("setPosition");
        $slider.css("visibility", "visible");
      }, 100);
    } catch (error) {
      console.error(`Error initializing slider ${selector}:`, error);
      $slider.css("visibility", "visible");
    }
  });
}

// Enhanced loading check
function checkSlickLoaded() {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();
    const timeout = 5000; // 5 second timeout

    function check() {
      if (window.jQuery && jQuery().slick) {
        resolve();
        return;
      }
      if (Date.now() - startTime > timeout) {
        reject(new Error("Slick loading timeout"));
        return;
      }
      setTimeout(check, 100);
    }
    check();
  });
}

// Initialize everything with better error handling
async function init() {
  try {
    await checkSlickLoaded();
    
    // Check if we're in Safari
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
    if (isSafari) {
      // Add Safari-specific CSS fixes
      const style = document.createElement("style");
      style.textContent = `
        .testimonial-slider {
          -webkit-transform: translate3d(0,0,0);
          -webkit-backface-visibility: hidden;
          -webkit-perspective: 1000;
        }
        .testimonial-slider .slick-slide {
          -webkit-transform: translate3d(0,0,0);
        }
      `;
      document.head.appendChild(style);
    }

    // Initialize sliders
    if (document.readyState === "complete") {
      initTestimonialSliders();
    } else {
      document.addEventListener("DOMContentLoaded", initTestimonialSliders);
    }

    // Reinitialize on Shopify section updates
    document.addEventListener("shopify:section:load", function(event) {
      initTestimonialSliders();
    });

    // Handle Shopify theme editor
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:select", function(event) {
        initTestimonialSliders();
      });
    }

  } catch (error) {
    console.error("Testimonial slider initialization failed:", error);
  }
}

// Start initialization
init();